import { createRouter, createWebHashHistory } from 'vue-router'
import { checkLoginStatus } from "@/client.ts";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/job-matching',
    name: 'JobMatching',
    component: () => import('@/views/JobMatching.vue')
  },
  {
    path: '/job-detail/:id',
    name: 'JobDetail',
    component: () => import('@/views/JobDetail.vue'),
    props: true
  },
  {
    path: '/career-planning',
    name: 'CareerPlanning',
    component: () => import('@/views/CareerPlanning.vue')
  },
  {
    path: '/employment-policy',
    name: 'EmploymentPolicy',
    component: () => import('@/views/Policy.vue')
  },
  {
    path: '/policy/:id',
    name: 'PolicyDetail',
    component: () => import('@/views/PolicyDetail.vue'),
    props: true
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局前置守卫 - 在每次导航时设置文档标题并检查用户登录状态
router.beforeEach((to, from, next) => {
  // 无论导航到哪个页面，都将标题设置为"AI职业规划"
  document.title = 'AI职业规划'
  
  // 需要登录才能访问的页面路径
  const authRequiredPages = [
    '/profile', 
    '/job-matching',
    '/job-detail',
    '/career-planning',
    '/employment-policy',
    '/policy'
  ];
  
  // 判断当前页面是否需要登录 - 检查路径是否以authRequiredPages中的任一值开头
  const requiresAuth = authRequiredPages.some(page => 
    to.path === page || (to.path.startsWith(page + '/'))
  );

  // 公共页面：首页和登录页不需要登录验证
  const isPublicPage = to.path === '/' || to.path === '/login';
  
  // 如果是公共页面，直接放行
  if (isPublicPage) {
    return next();
  }
  
  // 如果是需要验证的页面，检查用户是否已登录
  if (requiresAuth) {
    // 检查登录状态
    const isLoggedIn = checkLoginStatus();
    
    if (isLoggedIn) {
      // 用户已登录，允许访问
      console.log('用户已登录，允许访问');
      return next();
    } else {
      // 用户未登录，重定向到登录页
      console.log('用户未登录，重定向到登录页');
      return next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }
  
  // 其他情况直接放行
  return next();
});

export default router 